export default __webpack_public_path__ + "images/upload_73b3744d52657ba90d8b00bb091d0b2f.svg";